import { Consts } from '../dependencies';
import { forms } from '../config';

export const updateFormIdFactory = id => `${forms.updateSupplier}_${id}`;

export const updateModalIdFactory = id => `${Consts.modals.UPDATE_SUPPLIER}_${id}`;
export const deleteModalIdFactory = id => `${Consts.modals.DELETE_SUPPLIER}_${id}`;
